"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;
var _trim = _interopRequireDefault(require("lodash/fp/trim"));
var _validate = require("@active/core/userInput/validate");
/**
 * @deprecated
 * The internal trim logic and the `doNotTrim` option will be removed together in next major release.
 * Please do the trim before invoke this method based on requirement.
 * */
function required(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    doNotTrim = _ref.doNotTrim;
  return !(0, _validate.hasInput)(typeof value === 'string' && !doNotTrim ? (0, _trim["default"])(value) : value) ? 'react-ui.validation.required' : undefined;
}